<template>
    <div class="flex items-center ">
        <div class="flex h-screen">
            <transition name="sidebar-width">
                <aside :class="['sidebar', { 'sidebar-expanded': isExpanded }]" class="bg-gray-200 ">
                    <div class="flex flex-col p-2 mt-4">
                        <div v-if="isExpanded" class="flex items-center  justify-between ">
                            <span class="pl-5 ">识心智能</span>
                            <svg class="w-10 h-10 cursor-pointer" @click="toggleSidebar" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><clipPath id="clip1382_20239"><rect id="折叠边栏0730" width="30.000000" height="30.000000" fill="white" fill-opacity="0"></rect></clipPath></defs><rect id="折叠边栏0730" width="30.000000" height="30.000000" fill="#FFFFFF" fill-opacity="0"></rect><g clip-path="url(#clip1382_20239)"><rect id="rect" x="17.420410" y="12.316406" rx="1.000947" width="5.995172" height="2.001895" transform="rotate(137.159 17.420410 12.316406)" fill="currentColor" fill-opacity="1.000000"></rect><rect id="rect" x="12.959473" y="13.728516" rx="0.995190" width="6.002943" height="1.990380" transform="rotate(40.853 12.959473 13.728516)" fill="currentColor" fill-opacity="1.000000"></rect><path id="path" d="M20.1 25.5L9.9 25.51C9.48 25.51 9.06 25.47 8.65 25.39C8.24 25.3 7.84 25.18 7.45 25.02C7.06 24.86 6.69 24.66 6.34 24.43C5.99 24.19 5.67 23.92 5.37 23.63C5.07 23.33 4.81 23 4.58 22.65C4.34 22.3 4.15 21.93 3.98 21.54C3.82 21.15 3.7 20.75 3.62 20.34C3.54 19.93 3.5 19.51 3.5 19.09L3.5 10.93C3.5 10.51 3.54 10.1 3.62 9.68C3.7 9.27 3.82 8.87 3.98 8.48C4.15 8.09 4.34 7.72 4.58 7.37C4.81 7.02 5.07 6.69 5.37 6.39C5.67 6.1 5.99 5.83 6.34 5.6C6.69 5.36 7.06 5.16 7.45 5C7.84 4.84 8.24 4.72 8.65 4.64C9.06 4.55 9.48 4.51 9.9 4.51L20.1 4.5C20.52 4.5 20.94 4.54 21.35 4.62C21.76 4.7 22.16 4.83 22.55 4.99C22.94 5.15 23.31 5.35 23.66 5.58C24 5.82 24.33 6.08 24.62 6.38C24.92 6.68 25.19 7 25.42 7.35C25.65 7.7 25.85 8.07 26.01 8.46C26.17 8.85 26.3 9.25 26.38 9.67C26.46 10.08 26.5 10.5 26.5 10.92L26.5 19.07C26.5 19.5 26.46 19.91 26.38 20.32C26.3 20.74 26.17 21.14 26.01 21.53C25.85 21.92 25.65 22.29 25.42 22.64C25.19 22.99 24.92 23.31 24.62 23.61C24.33 23.91 24 24.17 23.66 24.41C23.31 24.64 22.94 24.84 22.55 25C22.16 25.16 21.76 25.29 21.35 25.37C20.94 25.45 20.52 25.5 20.1 25.5ZM9.9 6.6C9.61 6.6 9.33 6.63 9.05 6.69C8.78 6.74 8.51 6.82 8.24 6.93C7.98 7.04 7.73 7.18 7.5 7.33C7.26 7.49 7.04 7.67 6.84 7.87C6.64 8.07 6.46 8.29 6.31 8.53C6.15 8.77 6.02 9.01 5.91 9.28C5.8 9.54 5.72 9.81 5.66 10.09C5.61 10.37 5.58 10.65 5.58 10.93L5.58 19.09C5.58 19.37 5.61 19.65 5.66 19.93C5.72 20.21 5.8 20.48 5.91 20.74C6.02 21.01 6.15 21.26 6.31 21.49C6.46 21.73 6.64 21.95 6.84 22.15C7.04 22.35 7.26 22.53 7.5 22.69C7.73 22.85 7.98 22.98 8.24 23.09C8.51 23.2 8.78 23.28 9.05 23.33C9.33 23.39 9.61 23.42 9.9 23.42L20.1 23.41C20.38 23.41 20.67 23.37 20.94 23.32C21.22 23.26 21.49 23.18 21.75 23.07C22.01 22.96 22.26 22.83 22.5 22.67C22.73 22.51 22.95 22.33 23.15 22.13C23.35 21.93 23.53 21.71 23.69 21.48C23.85 21.24 23.98 20.99 24.09 20.73C24.2 20.47 24.28 20.2 24.33 19.92C24.39 19.64 24.42 19.36 24.42 19.07L24.42 10.92C24.42 10.64 24.39 10.35 24.33 10.07C24.28 9.79 24.2 9.52 24.09 9.26C23.98 9 23.85 8.75 23.69 8.51C23.53 8.28 23.35 8.06 23.15 7.86C22.95 7.66 22.73 7.48 22.5 7.32C22.26 7.16 22.01 7.03 21.75 6.92C21.49 6.81 21.22 6.73 20.94 6.67C20.67 6.62 20.38 6.59 20.1 6.59L9.9 6.6Z" fill="currentColor" fill-opacity="1.000000" fill-rule="nonzero"></path><path id="rect" d="M8.5 5.51L10.54 5.51L10.6 24.43L8.55 24.43L8.5 5.51Z" fill="currentColor" fill-opacity="1.000000" fill-rule="evenodd"></path></g></svg>
                        </div>
                        <div v-else class="flex items-center ml-2 ">
                            <div class="flex flex-col gap-8">
                                <!-- Logo -->
                                <el-tooltip content="展开/收起侧边栏" placement="right" effect="light">
                                    <img @click="toggleSidebar"
                                         src="@/assets/logo.png"
                                         alt="Logo"
                                          class="max-w-full max-h-full -ml-1 object-contain cursor-pointer hover-scale transform scale-125 origin-center" />
                                </el-tooltip>
                                 <!--返回按钮 -->
                                <el-tooltip content="返回主页" placement="right" effect="light">
                                    <svg @click="backTop"
                                         class="w-10 h-10 cursor-pointer text-gray-600 hover:text-gray-800"
                                         viewBox="0 0 24 24"
                                         fill="none"
                                         stroke="currentColor"
                                         stroke-width="2"
                                         stroke-linecap="round"
                                         stroke-linejoin="round">
                                        <path d="M19 12H5M12 19l-7-7 7-7" />
                                    </svg>
                                </el-tooltip>

                                 <!--新的草稿 -->
                                <el-tooltip content="新的草稿" placement="right" effect="light">
                                    <svg @click="newDraft"
                                         class="w-10 h-10 cursor-pointer"
                                         viewBox="0 0 30 30"
                                         fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <g clip-path="url(#clip1325_20400)"><path id="path" d="M10.51 26.52C10.35 26.52 10.19 26.49 10.04 26.43C9.89 26.37 9.76 26.28 9.64 26.17C9.53 26.06 9.44 25.93 9.37 25.78C9.31 25.63 9.28 25.48 9.28 25.32L9.25 22.87C8.89 22.82 8.53 22.74 8.19 22.62C7.84 22.5 7.51 22.36 7.19 22.19C6.86 22.01 6.56 21.81 6.28 21.58C5.99 21.36 5.73 21.11 5.49 20.83C5.25 20.56 5.04 20.27 4.85 19.96C4.67 19.65 4.51 19.33 4.38 18.99C4.25 18.65 4.16 18.3 4.09 17.95C4.03 17.6 4 17.24 4 16.88L4 10.38C4 9.99 4.03 9.6 4.11 9.21C4.19 8.82 4.31 8.45 4.46 8.08C4.61 7.72 4.8 7.37 5.03 7.04C5.25 6.72 5.5 6.41 5.78 6.13C6.07 5.86 6.38 5.61 6.71 5.39C7.04 5.17 7.4 4.98 7.77 4.83C8.14 4.68 8.52 4.57 8.91 4.49C9.31 4.41 9.7 4.38 10.11 4.38L14.35 4.38C14.5 4.38 14.63 4.4 14.77 4.46C14.9 4.51 15.02 4.59 15.12 4.69C15.22 4.79 15.3 4.9 15.35 5.03C15.41 5.16 15.43 5.3 15.43 5.44C15.43 5.58 15.41 5.71 15.35 5.84C15.3 5.97 15.22 6.09 15.12 6.19C15.02 6.29 14.9 6.37 14.77 6.42C14.63 6.47 14.5 6.5 14.35 6.5L10.11 6.5C9.85 6.5 9.59 6.53 9.34 6.58C9.08 6.62 8.83 6.7 8.6 6.8C8.36 6.89 8.13 7.01 7.91 7.15C7.7 7.3 7.5 7.46 7.31 7.64C7.13 7.82 6.97 8.01 6.82 8.22C6.68 8.44 6.56 8.66 6.46 8.9C6.36 9.13 6.28 9.37 6.23 9.62C6.18 9.87 6.16 10.12 6.16 10.38L6.16 16.88C6.16 17.14 6.18 17.39 6.23 17.65C6.29 17.9 6.36 18.15 6.46 18.39C6.56 18.62 6.69 18.85 6.83 19.07C6.98 19.28 7.15 19.48 7.33 19.66C7.52 19.85 7.72 20.01 7.94 20.15C8.16 20.3 8.39 20.42 8.63 20.52C8.87 20.62 9.13 20.69 9.38 20.74C9.64 20.79 9.9 20.82 10.17 20.82C10.33 20.82 10.49 20.85 10.64 20.91C10.79 20.97 10.92 21.06 11.04 21.17C11.15 21.28 11.24 21.41 11.31 21.56C11.37 21.71 11.4 21.86 11.41 22.02L11.42 23.53L14.15 21.56C14.85 21.07 15.62 20.82 16.48 20.82L19.87 20.82C20.13 20.82 20.38 20.79 20.64 20.74C20.89 20.69 21.14 20.62 21.38 20.52C21.62 20.42 21.85 20.3 22.06 20.16C22.28 20.02 22.48 19.86 22.66 19.68C22.84 19.5 23.01 19.3 23.15 19.09C23.29 18.88 23.42 18.66 23.52 18.42C23.61 18.19 23.69 17.94 23.74 17.69C23.79 17.44 23.82 17.19 23.82 16.94L23.82 13.58C23.82 13.44 23.84 13.3 23.9 13.17C23.95 13.04 24.03 12.93 24.13 12.83C24.23 12.73 24.35 12.65 24.48 12.6C24.62 12.54 24.75 12.52 24.9 12.52C25.04 12.52 25.18 12.54 25.31 12.6C25.44 12.65 25.56 12.73 25.66 12.83C25.76 12.93 25.84 13.04 25.9 13.17C25.95 13.3 25.98 13.44 25.98 13.58L25.98 16.94C25.98 17.33 25.94 17.72 25.86 18.11C25.78 18.5 25.67 18.87 25.51 19.24C25.36 19.6 25.17 19.95 24.95 20.27C24.73 20.6 24.47 20.9 24.19 21.18C23.9 21.46 23.6 21.71 23.26 21.93C22.93 22.15 22.58 22.33 22.21 22.48C21.83 22.63 21.45 22.75 21.06 22.83C20.67 22.9 20.27 22.94 19.87 22.94L17.19 22.94C16.33 22.94 15.56 23.19 14.86 23.69L11.24 26.29C11.02 26.44 10.78 26.52 10.51 26.52Z" fill="currentColor" fill-opacity="1.000000" fill-rule="nonzero"></path><rect id="rect" x="17.770508" y="6.396484" rx="1.062250" width="8.060087" height="2.124500" fill="currentColor" fill-opacity="1.000000"></rect><rect id="rect" x="20.718750" y="3.500000" rx="1.081197" width="2.162393" height="7.918844" fill="currentColor" fill-opacity="1.000000"></rect></g>
                                    </svg>
                                </el-tooltip>
                            </div>
                        </div>

                        <div v-if="isExpanded" class="transition-opacity duration-200">
                            <div class="flex">
                                <div class="rounded-lg bg-blue-500 p-2 max-w-max max-h-max cursor-pointer hover:bg-blue-600 mt-2" @click="newDraft">
                                    <i class="fas fa-plus ml-2 mr-2 text-white"></i>
                                    <span class="mr-2 text-white">新的草稿</span>
                                </div>
                            </div>
                            <div class="h-[calc(100vh-240px)] overflow-hidden overflow-y-auto mt-4">
                                <ul class="mt-2">
                                    <li v-for="(item, index) in historyList" :key="index">
                                        <div class="relative p-2 items-center justify-between rounded-lg cursor-pointer hover:bg-gray-300"
                                             :class="curHistoryIndex && curHistoryIndex === index ? 'bg-gray-300' : ''"
                                             @click="selectShowHistory(index)">
                                            <div class="flex group">
                                                <span class="w-40 whitespace-nowrap overflow-hidden text-ellipsis">{{item.title}}</span>
                                                <i @click.stop @click="toggleDropdown(index)"
                                                   :class="curHistoryIndex && curHistoryIndex === index ? 'opacity-100' : ''"
                                                   class="fas p-2 fa-ellipsis-h hover:bg-gray-400 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity"></i>
                                                <!--<div v-show="curSelectIndex"
                                                     class="action-menu fixed bg-white shadow-md py-1 mt-2 w-32 rounded-lg"
                                                     :style="{ top: dropdownPosition.top + 'px', left: dropdownPosition.left + 'px' }"
                                                     @click.stop>-->
<!--                                                    <a href="#" class="block px-4 py-2 text-gray-700 hover:bg-gray-200 rounded-lg" @click.prevent="renameHistory">
                                                        <i class="fas fa-pen mr-2"></i> 重命名
                                                    </a>-->
                                                    <!--<a href="#" class="block px-4 py-2 text-gray-700 hover:bg-gray-200 rounded-lg" @click.prevent="deleteHistory">
                                                        <i class="fas fa-trash mr-2"></i> 删除
                                                    </a>
                                                </div>-->
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <div v-if="curPage < (allNewsCnt+9)/10" class="" @click="getMoreList"><span class="">加载更多</span></div>
                            </div>
                        </div>
                    </div>
                </aside>
            </transition>
        </div>
        <div class="flex h-full justify-center  ">
            <div class="w-4/5 p-6 bg-white rounded-lg shadow-md  overflow-y-auto scrollable">
                <h1 class="text-2xl font-bold mb-6">新闻编辑</h1>

                <!-- 标题输入 -->
                <div class="mb-6">
                    <label for="title" class="block text-sm font-medium text-gray-700 mb-1">标题</label>
                    <input v-model="form.title"
                           type="text"
                           id="title"
                           class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                           placeholder="输入新闻标题" />
                </div>

                <!-- 标签输入 -->
                <div class="mb-6">
                    <label class="block text-sm font-medium text-gray-700 mb-1">标签</label>
                    <div class="flex flex-wrap gap-2">
                        <input v-model="newTag"
                               @keydown.enter.prevent="addTag"
                               type="text"
                               class="flex-1 min-w-[200px] px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                               placeholder="输入标签后按回车添加" />
                    </div>
                    <div class="flex flex-wrap gap-2 mt-2">
                        <span v-for="(tag, index) in form.tags"
                              :key="index"
                              class="inline-flex items-center px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
                            {{ tag }}
                            <button @click="removeTag(index)"
                                    type="button"
                                    class="ml-1 text-blue-600 hover:text-blue-900">
                                &times;
                            </button>
                        </span>
                    </div>
                </div>

                <!-- 封面图片 -->
                <div class="mb-6">
                    <label class="block text-sm font-medium text-gray-700 mb-1">封面图片</label>
                    <div class="flex items-center gap-4">
                        <div v-if="form.cover_path"
                             class="relative w-32 h-32 border rounded-md overflow-hidden">
                            <img :src="form.cover_path"
                                 alt="封面预览"
                                 class="w-full h-full object-cover" />
                            <button @click="form.cover_path = ''"
                                    class="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center">
                                &times;
                            </button>
                        </div>
                        <button @click="openFilePicker"
                                class="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-md text-sm">
                            {{ form.cover_path ? '更换封面' : '选择封面' }}
                        </button>
                        <input ref="fileInput"
                               type="file"
                               accept="image/*"
                               class="hidden"
                               @change="handleCoverImageChange" />
                    </div>
                </div>

                <!-- 富文本编辑器 -->
                <div class="mb-6 ">
                    <label class="block text-sm font-medium text-gray-700 mb-1">新闻内容编辑</label>
                    <quillEditor ref="editor"
                                 v-model="form.content_path"
                                 contentType="html"
                                 theme="snow"
                                 :modules="modules"
                                 class="h-64 mb-4" />
                </div>

                <!-- 发布设置 -->
                <div class="mb-6 border-t pt-12">
                    <h2 class="text-lg font-medium mb-4">发布设置</h2>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <!-- 状态选择 -->
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">状态</label>
                            <select v-model="form.status"
                                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                                <option value="draft">草稿</option>
                                <option value="published">发布</option>
                                <option value="closed">关闭</option>
                            </select>
                        </div>

                        <!-- 发布时间 -->
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">发布时间</label>
                            <input v-model="form.realse_at"
                                   type="datetime-local"
                                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>
                    </div>
                </div>

                <!-- 操作按钮 -->
                <div class="flex justify-end gap-4 pt-4 border-t">
                    <button @click="saveDraft"
                            class="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-md">
                        保存草稿
                    </button>
                    <button @click="submit"
                            class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md">
                            上传
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script >
    import { quillEditor } from 'vue-quill-editor'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.bubble.css'
    import 'quill/dist/quill.snow.css';
    import axios from 'axios';
    /*import { useLocalStorage } from '@vueuse/core';*/

    export default {

        beforeDestroy() {
            localStorage.removeItem('isAuthenticated');
        },
        components: {
            quillEditor
        },
        data() {
            return {
                curHistoryIndex:null,
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote', 'code-block'],
                        [{ 'header': 1 }, { 'header': 2 }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'indent': '-1' }, { 'indent': '+1' }],
                        [{ 'direction': 'rtl' }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'font': [] }],
                        [{ 'align': [] }],
                        ['clean'],
                        ['link', 'image', 'video']
                    ]
                },
                dropdownPosition: {
                    top: 0,
                    left: 0
                },
                allNewsCnt: 0,
                curPage:1,
                curSelectIndex: null,
                editor: null,
                fileInput: null,
                newTag: '',
                isExpanded: false,
                historyList: [],
                getMoreMode:false,
                form: {
                    id:null,
                    title: '',
                    tags: [],
                    cover_path: '',
                    content_path: '',
                    status: 'draft',
                    realse_at:null
                }
            }
        },
        mounted() {
            // 从本地存储加载草稿
            if (this.draft) {
               Object.assign(this.form, this.draft);
            }
            console.log("xxxx");
            const draftData = this.getDraftFromLocal(-1);
            if (draftData) {
                this.form = JSON.parse(JSON.stringify(draftData));
            }
            this.getNewsList();
        },
        methods: {
            cleanDraft() {
                const newsId = this.form.id ? this.form.id : -1;
                try {
                    const key = `news_draft_${newsId}`;
                    localStorage.removeItem(key);
                    this.form = {
                        id: null,
                        title: '',
                        tags: [],
                        cover_path: '',
                        content_path: '',
                        status: 'draft',
                        realse_at: null
                    };
                } catch (error) {
                    console.error('clean:', error);
                }
            },
            getMoreList() {
                if (this.curPage < (this.allNewsCnt+9)/10) {
                    this.curPage++;
                    this.getMoreMode = true;
                    this.getNewsList();
                }
            },
            addTag() {
                if (this.newTag.trim() && !this.form.tags.includes(this.newTag.trim())) {
                if (this.form.tags.length >= 5) {
                    alert('tag 在精不在多.')
                    this.newTag = '';
                } else {
                    this.form.tags.push(this.newTag.trim());
                    this.newTag = '';
                }
            }
            },
            removeTag(index) {
                this.form.tags.splice(index, 1);
            },
            openFilePicker() {
                this.$refs.fileInput.click();
            },
            handleCoverImageChange(e) {
                const file = e.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (event) => {
                        this.form.cover_path = event.target.result;
                    };
                    reader.readAsDataURL(file);
                }
            },
            saveDraft() {
                const draftData = { ...this.form, status: 'draft' };
                const newsId = this.form.id ? this.form.id : -1;
                try {
                    const key = `news_draft_${newsId}`;
                    localStorage.setItem(key, JSON.stringify(draftData));
                    this.$message.success("草稿保存成功！");
                } catch (error) {
                    console.error('保存草稿失败:', error);
                }
            },
            getDraftFromLocal(newsId) {
                try {
                    const key = `news_draft_${newsId}`;
                    const draft = localStorage.getItem(key);
                    return draft ? JSON.parse(draft) : null;
                } catch (error) {
                    console.error('读取草稿失败:', error);
                    return null;
                }
            },
            submit() {
                if (!this.form.title.trim()) {
                    alert('请输入标题');
                    return;
                }
                if (!this.form.content_path.trim()) {
                    alert('请输入内容');
                    return;
                }
                console.log('提交数据:', this.form);
                this.newUpdate();
            },
            backTop() {
                this.$router.push('/');
            },
            newDraft() {
                // 新建草稿实现
                this.form= {
                    id: null,
                    title: '',
                    tags: [],
                    cover_path: '',
                    content_path: '',
                    status: 'draft'
                }
            },
            deleteHistory() {
                // 删除历史实现
            },
            renameHistory() {
                // 重命名历史实现
            },
            formatDayInfo() {
                // 格式化日期信息实现
            },
            toggleDropdown(index) {
                console.log(index);
                if (!this.curSelectIndex) {
                    this.curSelectIndex = true;
                } else {
                    this.curSelectIndex = null;
                }
            },
            selectShowHistory(index) {
                if (this.curHistoryIndex === index) {
                    return;
                }
                this.curHistoryIndex = index;
                
                this.form = JSON.parse(JSON.stringify(this.historyList[index]));
                this.form.tags = this.form.tags.split(',').map(tag => tag.trim())

                const draftData = this.getDraftFromLocal(this.form.id ? this.form.id : -1);
                if (draftData) {//存在缓存
                    this.$confirm('该新闻存在草稿，是否编辑草稿？', '提示', {
                        confirmButtonText: '编辑草稿',
                        cancelButtonText: '显示记录',
                        type: 'warning'
                    }).then(() => {
                        // 用户点击了确认
                        this.$message({
                            message: '编辑草稿',
                            type: 'success'
                        });
                        this.form = JSON.parse(JSON.stringify(draftData));
                        console.log(this.form);
                    }).catch(() => {
                        // 用户点击了取消
                        this.$message({
                            message: '编辑服务器内容',
                            type: 'success'
                        });
                    });
                }
            },
            toggleSidebar() {
                this.isExpanded = !this.isExpanded;
                if (this.isExpanded && this.historyList.length == 0) {
                    this.getNewsList();
                }
            },
            //host
            //更新，add
            async test11() {
                try {
                   
                    const response = await axios({
                        method: 'get',
                        timeout: 60 * 1000,
                        url: 'api/news/get/18',
                        headers: {
                            'accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    });

                    if (response.status === 200) {
                        console.log(response.data.info);
                        this.form = response.data.info;
                    } else {
                        this.$message({
                            message: '更新失败，请稍后重试',
                            type: 'error'
                        });
                        return false;
                    }
                } catch (error) {
                    console.error('Failed to create summary:', error);
                    this.$message({
                        message: '更新失败，请稍后重试。',
                        type: 'error'
                    });
                    return false;
                }
            },
            async newUpdate() {
                const news_id = this.form.id ? this.form.id : -1;
                try {
                    console.log("this.form.cover_path");
                    console.log(this.form.cover_path);
                    var brief = null;
                    if (this.form.content_path && this.form.content_path.length > 0 ) {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(this.form.content_path, 'text/html');
                        const text = doc.body.textContent || '';
                        brief =  text.length > 64? text.substring(0, 64) + '...': text;
                    }
                    const requestData = {
                        "news_id": news_id,
                        "info": {
                            title: this.form.title,
                            tags: this.form.tags.join(","),
                            cover_path: this.form.cover_path,
                            content_path: this.form.content_path,
                            status: this.form.status,
                            realse_at: this.form.realse_at,
                            brief: brief
                        }
                    };

                    if(this.form.status == "published" && !requestData.info.realse_at){
                        requestData.info.realse_at =  new Date().toLocaleString('zh-CN', {
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit'
                            }); 
                    }
                    const response = await axios({
                        method: 'post',
                        timeout: 60 * 1000,
                        url: 'api/news/update',
                        headers: {
                            'accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        data: requestData
                    });

                    if (response.status === 200) {
                        console.log("update success ");
                        this.$message.info({ message: '新闻上传成功！', duration: 3000 });
                        this.cleanDraft()
                        //this.getNewsList();
                    } else {
                        this.$message({
                            message: '更新失败，请稍后重试',
                            type: 'error'
                        });
                        return false;
                    }
                } catch (error) {
                    console.error('Failed to create summary:', error);
                    this.$message({
                        message: '更新失败，请稍后重试。',
                        type: 'error'
                    });
                    return false;
                }
            },
            async delNew() {
                if (!this.form.id) {
                    return;
                }
                try {
                    const requestData = {
                        delid: this.form.id,
                    };
                    const response = await axios({
                        method: 'post',
                        timeout: 60 * 1000,
                        url: 'http://localhost:64081/news/del',
                        headers: {
                            'accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        data: requestData
                    });

                    if (response.status === 200) {
                        console.log("del success ");
                        this.getNewsList();
                    } else {
                        this.$message({
                            message: '删除失败，请稍后重试',
                            type: 'error'
                        });
                        return false;
                    }
                } catch (error) {
                    console.error('Failed to create summary:', error);
                    this.$message({
                        message: '删除失败，请稍后重试。',
                        type: 'error'
                    });
                    return false;
                }
            },
            async getNewsList() {
                try {
                    const requestData = {
                        page: this.curPage
                    };
                    const response = await axios({
                        method: 'post',
                        timeout: 30 * 1000,
                        //url: '/api/train/make_summary',
                        url: `api/news/list-m`,
                        headers: {
                            'accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        data: requestData
                    });

                    if (response.status === 200) {
                        if (response.data.code == "00") {
                            if (this.getMoreMode) {
                                this.allNewsCnt = response.data.total;
                                this.historyList = [...this.historyList, ...response.data.infos];
                                this.getMoreMode = false;
                            } else {
                                this.allNewsCnt = response.data.total;
                                this.historyList = [...this.historyList, ...response.data.infos];
                            }
                        }
                    } else {
                        this.$message({
                            message: '获取新闻列表失败，请稍后重试！',
                            type: 'error'
                        });
                        return false;
                    }
                } catch (error) {
                    console.error('Failed to create summary:', error);
                    this.$message({
                        message: '获取新闻列表失败，请稍后重试。',
                        type: 'error'
                    });
                    return false;
                }
            },   
    }
}
</script>
